import { cn } from "@/lib/utils";

const TitleH2 = ({
  className,
  title,
}: {
  className?: string;
  title: string;
}) => {
  return (
    <h2
      className={cn(
        "text-primary leading-[1.35] font-light tracking-normal text-[calc(28px*var(--heading-scale,1))] md:text-[calc(40px*var(--heading-scale,1))] xl:text-[calc(48px*var(--heading-scale,1))] xl:leading-[1.1698] 2xl:text-[calc(53px*var(--heading-scale,1))]",
        className,
      )}
    >
      {title}
    </h2>
  );
};

export default TitleH2;
